import { render, staticRenderFns } from "./finalizar-renovacao.vue?vue&type=template&id=5da94e8c&scoped=true"
import script from "./finalizar-renovacao.vue?vue&type=script&lang=js"
export * from "./finalizar-renovacao.vue?vue&type=script&lang=js"
import style0 from "./finalizar-renovacao.vue?vue&type=style&index=0&id=5da94e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da94e8c",
  null
  
)

export default component.exports